"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successResponse = exports.nonSuccessResponse = void 0;
const nonSuccessResponse = (value = {}) => (Object.assign({ success: false, value: "", hash: "" }, value));
exports.nonSuccessResponse = nonSuccessResponse;
const successResponse = (value = {}) => (Object.assign({ success: true, value: "", hash: "" }, value));
exports.successResponse = successResponse;
